import { fieldRef, previousRaRef, rateNodeFromSource, op } from './astHelpers';

/**
 * Balance recovery: MIN(PERCENTAGE(base, rate), outstanding)
 * outstanding = PREVIOUS_RA outstanding field, or original advance if missing.
 */
export const buildBalanceRecoveryFormula = (cfg = {}) => {
  const baseCode = cfg.baseFieldCode || cfg.originalAdvanceFieldCode;
  const outstandingCode = cfg.previousOutstandingFieldCode || cfg.originalAdvanceFieldCode;
  if (!baseCode && !outstandingCode) return null;

  const recoveryMethod = String(cfg.recoveryMethod || 'PERCENTAGE').toUpperCase();
  let recoveryExpr;
  if (recoveryMethod === 'FIXED') {
    recoveryExpr = rateNodeFromSource(cfg);
  } else if (baseCode) {
    recoveryExpr = op('PERCENTAGE', [fieldRef(baseCode), rateNodeFromSource(cfg)]);
  } else {
    recoveryExpr = rateNodeFromSource(cfg);
  }

  if (cfg.capToOutstanding === false || !outstandingCode) {
    return recoveryExpr;
  }

  const outstanding = previousRaRef(outstandingCode, 0);
  return op('MIN', [recoveryExpr, outstanding]);
};
